import React from "react";
import { observer } from "mobx-react-lite";
import { SvgIcon, clsx, Typography } from "@gemlightbox/core-kit";

import { useStores } from "src/hooks";
import { LocaleCodeTypes } from "src/store/locale/locale-generated.store.types";

import { ReactComponent as FlagSVG } from "src/external-ts/assets/images/flag.svg";
import styles from "./starter-plan-badge.module.css";

export type StarterPlanBadgeProps = {
  className?: string;
  split?: boolean;
  hideInterval?: boolean;
  secondaryTextColor?: boolean;
};

export const StarterPlanBadge: React.FC<StarterPlanBadgeProps> = observer(
  ({
    className = "",
    split = false,
    hideInterval = false,
    secondaryTextColor = false,
  }: StarterPlanBadgeProps) => {
    const { subscriptionsStore, localeStore } = useStores();

    const { planInterval } = subscriptionsStore;

    return (
      <div
        className={clsx(
          styles.starterPlanBadgeContainer,
          { [styles.split]: split },
          { [styles.secondaryTextColor]: secondaryTextColor },
          className,
        )}
      >
        <SvgIcon className={styles.starterPlanBadgeIcon} icon={FlagSVG} />
        <Typography size="medium600">
          Starter
          {!hideInterval && planInterval && (
            <span className={styles.typeText}>
              &nbsp;
              {localeStore.t(
                `components.business["subscription-badges"].intervals["${planInterval}"]` as LocaleCodeTypes,
              )}
            </span>
          )}
        </Typography>
      </div>
    );
  },
);

export default StarterPlanBadge;
